/**
 * Get a key's value from the URL query string.
 *
 * @param key
 * @returns the key's value
 */
export default function getQueryParameter(
  key: string,
  win: Window = window
): string | null {
  const p = new URLSearchParams(win.location.search);

  return p.get(key);
}
